/**
 * An invite code that arrived on `/pair?code=` while the visitor was signed
 * out. It lives in `sessionStorage` (this tab only, gone when it closes) so the
 * sign-in detour does not lose it.
 */
export const PAIR_CODE_STORAGE_KEY = 'hc_pair_code';

export function storePairCode(code: string): void {
  try {
    sessionStorage.setItem(PAIR_CODE_STORAGE_KEY, code);
  } catch {
    /* private mode: the person can type the code instead */
  }
}

export function readPairCode(): string | null {
  try {
    return sessionStorage.getItem(PAIR_CODE_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearPairCode(): void {
  try {
    sessionStorage.removeItem(PAIR_CODE_STORAGE_KEY);
  } catch {
    /* nothing to clear */
  }
}
